<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body form text-left">
      <br />
      <div class="input-group ">
        <span class="input-group-addon">編號</span>
        <div class="form-control form-info">
          {{memberInfo.user_no}}
        </div>
      </div>
      <br />
      <div>
        <div class="input-group ">
          <span class="input-group-addon">ID</span>
          <div class="form-control form-info">
            {{memberInfo.shopper_id}}
          </div>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group ">
          <span class="input-group-addon">暱稱</span>
          <div class="form-control form-info">
            {{memberInfo.nickname}}
          </div>
        </div>
        <br />
      </div>
      <div>
        <div class="input-group ">
          <span class="input-group-addon">登入類型</span>
          <div class="form-control form-info">
            <!-- 自建帳號 -->
            <span v-if="memberInfo.create_account_type == 1"><img class="img-login-type img-round" src="/static/img/icon/phone.svg"></span>
            <!-- FB 帳號 -->
            <span v-if="memberInfo.create_account_type == 2"><img class="img-login-type img-round" src="/static/img/icon/fb.png"></span>
            <!-- Google 帳號 -->
            <span v-if="memberInfo.create_account_type == 3"><img class="img-login-type img-round" src="/static/img/icon/google.png"></span>
            <!-- LINE 帳號 -->
            <span v-if="memberInfo.create_account_type == 4"><img class="img-login-type img-round" style="margin-right: 8px;" src="/static/img/icon/line.png"></span><span v-if="memberInfo.create_account_owner_type == 2 && memberInfo.create_account_type == 4">({{memberInfo.create_account_owner_brand_name}})</span><span v-else-if="memberInfo.create_account_owner_type == 1 && memberInfo.create_account_type == 4">(你訂)</span>
            <!-- 街口 -->
            <span v-if="memberInfo.create_account_type == 5"><img class="img-login-type img-round" src="/static/img/icon/jkos.svg"></span>
            <!-- 車廠 -->
            <span v-if="memberInfo.create_account_type == 6"><img class="img-login-type img-round" src="/static/img/icon/car.png"></span>
            <!-- 品牌既有會員 -->
            <span v-if="memberInfo.create_account_type == 7"><img class="img-login-type img-round" src="/static/img/icon/existing-member.png"></span>
          </div>
        </div>
        <br />
      </div>
      <div v-if="memberInfo.sex">
        <div class="input-group">
          <span class="input-group-addon">性別</span>
          <div class="form-control form-info">
            <span v-if="memberInfo.sex == 1" class="text-blue"><i class="fa fa-male" aria-hidden="true"></i></span>
            <span v-if="memberInfo.sex == 2"  class="text-red"><i class="fa fa-female" aria-hidden="true"></i></span>
          </div>
        </div>
        <br />
      </div>
      <div  v-if="memberInfo.email">
        <div class="input-group ">
          <span class="input-group-addon">信箱</span>
          <div class="form-control form-info">
            {{memberInfo.email}}
          </div>
        </div>
        <br />
      </div>
      <div v-if="memberInfo.birth">
        <div class="input-group ">
          <span class="input-group-addon">生日</span>
          <div class="form-control form-info">
            {{memberInfo.birth}}
          </div>
        </div>
        <br />
      </div>
      <div  v-if="info">
        <div>
          <div class="input-group ">
            <span class="input-group-addon">手機</span>
            <input class="form-control" placeholder="" type="text" v-model="memberInfo.phone" maxlength="10" @keyup="verityPhone()" id="phone">
          </div>
          <br />
        </div>
        <div class="input-group mb-3" style="display: flex;" v-if="!memberInfo.is_phone_valid">
            <div class="input-group-prepend" style="display: flex;">
              <button class="btn btn-danger m-r-5 m-y-5" data-toggle="modal" data-target="#reMessageVerityModal">
                簡訊驗證次數歸零
              </button>
              <button class="btn btn-danger m-r-5 m-y-5" data-toggle="modal" data-target="#reMessageWrongModal">
                驗證錯誤次數歸零
              </button>
              <button class="btn btn-danger m-r-5 m-y-5" data-toggle="modal" data-target="#sendMessageModal" >
                產生驗證碼
              </button>
            </div>
            <input class="form-control" v-model="v_code" type="text">
            <div class="input-group-append" style="display: flex">
              <button class="btn btn-secondary m-l-5 m-y-5" :class="{'btn-success': v_code !== '' }" :disabled="v_code ===''" v-clipboard:copy="v_code" v-clipboard:success="copySuccess">複製</button>
            </div>
        </div>
        <span v-if="!memberInfo.is_phone_valid"><br /></span>
        <div class="input-group">
          <span class="input-group-addon">
            停權
          </span>
          <div class="form-group">
            <select class="form-control" v-model="memberInfo.is_suspend">
              <option value="0">正常</option>
              <option value="1">停權</option>
            </select>
          </div>
        </div>
        <br />
        <div v-if="memberInfo.create_account_type != 1">
          <div class="input-group">
            <span class="input-group-addon">
              手機驗證
            </span>
            <div class="form-group">
              <select class="form-control" v-model="memberInfo.is_phone_valid">
                <option value="1">通過</option>
                <option value="0">未通過</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <div class="input-group">
          <span class="input-group-addon">
            {{memberInfo.create_account_type === 1 ? '手機驗證' : '開通'}}
          </span>
          <div class="form-group">
            <select class="form-control" v-model="memberInfo.is_active">
              <option :value="1">啟動</option>
              <option :value="0">未啟動</option>
            </select>
          </div>
        </div>
        <br />
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              每日交易金額上限
            </span>
            <input class="form-control" placeholder="" type="text" v-model="memberInfo.daily_trade_limit" maxlength="6">
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              居住地
            </span>
            <div class="form-control">
              {{ cityAreaName(citySelect, areaSelect) }}
            </div>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              地址
            </span>
            <input class="form-control" placeholder="請輸入地址" type="text" v-model.trim="memberInfo.address_short">
          </div>
          <br />
        </div>
        <!-- 備註 | 只有註冊來源為「品牌既有會員」的副帳號，有此「備註」欄位 -->
        <div v-if="memberInfo.create_account_type === 7 && !memberInfo.main_shopper_id">
          <div class="input-group">
            <span class="input-group-addon">
              備註
            </span>
            <input class="form-control" placeholder="請輸入備註" type="text" v-model="memberInfo.remark">
          </div>
          <br />
        </div>
        <!-- End 備註 -->
      </div>

      <!-- /.box-body -->
    </div>
    <div class="box-footer text-center">
      <button class="btn btn-default" @click="goBack">
        取消
      </button>
      <button class="btn btn-success" v-if="!info">
        新增
      </button>
      <button class="btn btn-success" v-if="info" @click="checkInputEmpty">
        修改
      </button>
    </div>
    <br />
    <m-modal class="text-left" :option="reMessageVerityOption" @trigger="trigger"></m-modal>
    <m-modal class="text-left" :option="reMessageWrongOption" @trigger="trigger"></m-modal>
    <m-modal class="text-left" :option="sendMessageOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import $ from 'jquery'
import matcherModal from '../../../elements/Modal.vue'
export default {
  props: {
    'info': {
      type: Object
    }
  },
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      areaSelect: '', // 區域選擇
      cityAreaList: [], // 縣市區域列表
      citySelect: '', // 縣市選擇
      cityOption: [], // 縣市選項
      v_code: '',
      memberInfo: {},
      reMessageVerityOption: {
        id: 'reMessageVerityModal',
        title: '簡訊驗證次數歸零',
        body: '使用者將可在一天內重新發送三次手機驗證',
        btns: [
          {
            name: '取消'
          },
          {
            name: '歸零',
            event: 'reMessageVerity'
          }
        ]
      },
      reMessageWrongOption: {
        id: 'reMessageWrongModal',
        title: '驗證錯誤次數歸零',
        body: '使用者將可重新輸入三次手機驗證碼',
        btns: [
          {
            name: '取消'
          },
          {
            name: '歸零',
            event: 'reMessageWrong'
          }
        ]
      },
      sendMessageOption: {
        id: 'sendMessageModal',
        title: '產生驗證碼',
        body: '重置使用者驗證次數與重試次數，並直接產生認證碼',
        btns: [
          {
            name: '取消'
          },
          {
            name: '產生',
            event: 'sendMessage'
          }
        ]
      }
    }
  },
  methods: {
    cityAreaName (cityCode, areaCode) {
      if (!cityCode || !areaCode) return '無居住地資料'
      const city = this.cityAreaList.find((item) => {
        return item.city_code === cityCode
      })
      const area = city.area_list.find((item) => {
        return item.area_code === areaCode
      }) || { name: '' }
      return city.name + area.name
    },
    copySuccess () {
      this.$notify({
        title: '已複製驗證碼',
        duration: 3000,
        type: 'success',
        width: 400
      })
    },
    verityPhone () {
      var e = $('#phone')
      this.memberInfo.phone = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    trigger (event) {
      // console.log(event)
      if (event === 'reMessageVerity') {
        this.reMessageVerity()
      } else if (event === 'reMessageWrong') {
        this.reMessageWrong()
      } else if (event === 'sendMessage') {
        this.checkPhone()
      }
    },
    checkPhone () {
      if (!this.getInput.phone) {
        this.$notify({
          title: '提醒',
          text: '請填寫手機號碼！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (this.getInput.phone.length !== 10) {
        this.$notify({
          title: '提醒',
          text: '請填寫正確的手機號碼！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else this.sendMessage()
    },
    sendMessage () {
      var self = this
      var data = {
        phone: this.getInput.phone,
        skip_send_sms: 1
      }
      var url = '/shopper/verifyPhoneCode/' + this.$route.params.user_id
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: '產生成功',
              text: '驗證碼產生成功',
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.v_code = response.data.verify_code
          }
        })
      }
    },
    reMessageVerity () {
      var self = this
      var data = {
        clear_phone_valid_history: 1
      }
      var url = '/shopper/' + this.$route.params.user_id
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: '更新成功',
              text: '簡訊驗證次數歸零',
              duration: 3000,
              type: 'success',
              width: 400
            })
          }
        })
      }
    },
    reMessageWrong () {
      var self = this
      var data = {
        clear_phone_valid_fail_history: 1
      }
      var url = '/shopper/' + this.$route.params.user_id
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: '更新成功',
              text: '簡訊驗證次數歸零',
              duration: 3000,
              type: 'success',
              width: 400
            })
          }
        })
      }
    },
    getCityAreaList () {
      const self = this
      const url = '/platform/cityAreaList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.cityAreaList = response.data.list
          for (let i = 0; i < self.cityAreaList.length; i++) {
            const option = {name: self.cityAreaList[i].name, value: self.cityAreaList[i].city_code}
            self.cityOption.push(option)
          }
        }
      })
    },
    getMemberById () {
      var self = this
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id
        this.loginType = 99
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info
            self.citySelect = self.memberInfo.city_code
            self.areaSelect = self.memberInfo.area_code
          }
        })
      }
    },
    checkInputEmpty () {
      if (typeof this.memberInfo.daily_trade_limit !== 'number' && !this.memberInfo.daily_trade_limit) {
        this.$notify({
          title: '請填寫交易金額',
          text: '交易金額限制為0~200000',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (this.getInput.phone.length !== 10) {
        this.$notify({
          title: '提醒',
          text: '請填寫正確的手機號碼',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.updateMemberInfo()
      }
    },
    updateMemberInfo () {
      const memberInfo = this.memberInfo
      var self = this
      var data = {
        is_phone_valid: memberInfo.is_phone_valid,
        is_suspend: memberInfo.is_suspend,
        is_active: memberInfo.is_active,
        daily_trade_limit: parseInt(this.getInput.daily_trade_limit, 10)
      }
      if (memberInfo.create_account_type === 1) {
        data.is_phone_valid = memberInfo.is_active
      }
      // if (memberInfo.phone) data[phone] = memberInfo.phone
      var url = '/shopper/' + this.$route.params.user_id
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: '更新成功',
              text: '已更新會員資訊',
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.push('/memberTable')
          }
        })
      }
    },
    goBack () {
      this.$router.push('/memberTable')
    }
  },
  created () {
    this.getMemberById()
  },
  mounted () {
    this.getCityAreaList()
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getInput () {
      var mInfo = this.memberInfo
      var phone = ''
      if (mInfo.phone) phone = mInfo.phone.toString()
      return {
        daily_trade_limit: this.checkInput(mInfo.daily_trade_limit.toString()),
        phone: this.checkInput(phone.toString())
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MemberFormTemp.vue?2b98e4ea